export const defaultLocale = 'ru';

export const locales = [
  {
    code: 'ru',
    name: 'Русский',
    dir: 'rus',
  },
  {
    code: 'kz',
    name: 'Казахский',
    dir: 'kzt',
  },
];
